module.exports = __webpack_public_path__ + "img/login.5a47ece1.png";